// sendPlayerSignal — the one path a walker's whistle/mark takes out of the
// client. Optimistically renders locally (the sim echo is deduped by id), so
// the mark appears instantly even on a slow link; the shared cooldown stops
// both keyboard and button spam in one place.

import useGameStore from '../stores/gameStore'
import { playWhistle } from './audio/footsteps'

export const SIGNAL_MARKS = ['wave', 'orb', 'question', 'apple', 'note']

const COOLDOWN_MS = 3000
let lastAt = 0

export function sendPlayerSignal(kind, pos) {
  const now = Date.now()
  if (now - lastAt < COOLDOWN_MS) return false
  if (!pos || !Number.isFinite(pos.x) || !Number.isFinite(pos.z)) return false
  lastAt = now
  const g = useGameStore.getState()
  const id = `sig_${now}_${Math.random().toString(36).slice(2, 7)}`
  g.addSignal({ id, kind, pos: { x: pos.x, z: pos.z } })
  g.signalSender?.({ type: 'player_signal', kind, pos: { x: pos.x, z: pos.z }, id })
  if (kind === 'whistle') playWhistle()
  return true
}
